import { Button, Card, CardHeader, CardHeaderActions, CardHeading, ConfirmationDialog, Id } from "@dgs/core";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useEventActions } from "../../events/useEventActions";

interface Props {
	id: Id;
	className?: string;
	shouldNavigate?: boolean;
}

const WarningCard = styled(Card)`
	margin-bottom: ${({ theme }) => theme.spacing(5)};
	background-color: ${({ theme }) => theme.colors.palette.warning.light.base};
`;

export const ArchivedEventBanner: FC<Props> = ({ id, className }) => {
	const { t } = useTranslation();
	const { restoreEvent } = useEventActions();
	const [eventIdToRestore, setEventIdToRestore] = useState<Id | null>(null);

	return (
		<WarningCard className={className}>
			<CardHeader>
				<CardHeading>{t("This event is archived")}</CardHeading>
				<CardHeaderActions>
					<Button onClick={() => setEventIdToRestore(id)} title={t("Restore")} size="small" type="button">
						{t("Restore")}
					</Button>
					<ConfirmationDialog
						heading={t("Restore event")}
						labels={{ close: t("Close"), confirm: t("Confirm") }}
						open={eventIdToRestore !== null}
						onClose={() => setEventIdToRestore(null)}
						action={() => restoreEvent(eventIdToRestore)}
					>
						{t("Are you sure you want to restore this event?")}
					</ConfirmationDialog>
				</CardHeaderActions>
			</CardHeader>
		</WarningCard>
	);
};
